// ─────────────────────────────────────────────────────────────────────────────
// v2 icon system
//   <Glyph name>   — thin line symbol (1.6 stroke, round caps), inherits color.
//   <Tile name>    — glossy iOS-style app tile: system-colour gradient + white glyph.
// Hand-drawn on a 24px grid so weights match across the set.
// ─────────────────────────────────────────────────────────────────────────────

const P = {
  home: <><path d="M3.5 10.2 12 3.5l8.5 6.7V19a1.5 1.5 0 0 1-1.5 1.5h-4v-5.5h-6V20.5H5A1.5 1.5 0 0 1 3.5 19z" /></>,
  invoice: <><path d="M6.5 3h7.6L18.5 7.4V19.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z" /><path d="M14 3v4.5h4.5M8.5 12h7M8.5 15.5h7M8.5 19h4" /></>,
  cart: <><path d="M3 4h2.2l2.2 10.6a1.6 1.6 0 0 0 1.6 1.3h8.1a1.6 1.6 0 0 0 1.6-1.2L20.5 8H6.3" /><circle cx="9.5" cy="19.5" r="1.3" /><circle cx="17" cy="19.5" r="1.3" /></>,
  box: <><path d="M12 3 20 7.3v9.4L12 21l-8-4.3V7.3z" /><path d="M4 7.3 12 11.6l8-4.3M12 11.6V21" /></>,
  people: <><circle cx="9" cy="8" r="3.4" /><path d="M2.8 19.5c.5-3.3 3-5.4 6.2-5.4s5.7 2.1 6.2 5.4" /><path d="M15.5 4.9a3.3 3.3 0 0 1 0 6.3M17.6 14.4c2 .6 3.3 2.5 3.6 5.1" /></>,
  badge: <><path d="M12 3.2 14.3 5l2.9-.2.9 2.8 2.4 1.7-.9 2.7.9 2.7-2.4 1.7-.9 2.8-2.9-.2L12 20.8 9.7 19l-2.9.2-.9-2.8-2.4-1.7.9-2.7-.9-2.7 2.4-1.7.9-2.8 2.9.2z" /><path d="m9.3 14.7 5.4-5.4M9.6 9.6h.01M14.4 14.4h.01" /></>,
  chart: <><path d="M4 20.5h16.5" /><rect x="5" y="11" width="3.2" height="7" rx="1" /><rect x="10.4" y="6.5" width="3.2" height="11.5" rx="1" /><rect x="15.8" y="3.5" width="3.2" height="14.5" rx="1" /></>,
  clients: <><rect x="3.5" y="3.5" width="17" height="17" rx="4.5" /><circle cx="12" cy="10" r="2.9" /><path d="M7 18.2c.8-2.3 2.7-3.6 5-3.6s4.2 1.3 5 3.6" /></>,
  wallet: <><path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H17v2.5" /><path d="M4 7.5V17a2.5 2.5 0 0 0 2.5 2.5h12A1.5 1.5 0 0 0 20 18v-9a1.5 1.5 0 0 0-1.5-1.5H6.5" /><path d="M16.5 13.2h.01" /></>,
  bell: <><path d="M6.2 16.5V11a5.8 5.8 0 0 1 11.6 0v5.5l1.4 1.8H4.8z" /><path d="M10 20.5a2.2 2.2 0 0 0 4 0" /></>,
  phone: <><path d="M5.5 3.8h3l1.5 4.2-2 1.3a10.5 10.5 0 0 0 6.7 6.7l1.3-2 4.2 1.5v3A1.8 1.8 0 0 1 18.4 20.3 15.8 15.8 0 0 1 3.7 5.6 1.8 1.8 0 0 1 5.5 3.8z" /></>,
  search: <><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4.5 4.5" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 2.8v2.4M12 18.8v2.4M21.2 12h-2.4M5.2 12H2.8M18.5 5.5l-1.7 1.7M7.2 16.8l-1.7 1.7M18.5 18.5l-1.7-1.7M7.2 7.2 5.5 5.5" /></>,
  more: <><circle cx="12" cy="5.5" r="1.2" fill="currentColor" /><circle cx="12" cy="12" r="1.2" fill="currentColor" /><circle cx="12" cy="18.5" r="1.2" fill="currentColor" /></>,
  grid: <><rect x="4" y="4" width="6.5" height="6.5" rx="2" /><rect x="13.5" y="4" width="6.5" height="6.5" rx="2" /><rect x="4" y="13.5" width="6.5" height="6.5" rx="2" /><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="2" /></>,
  plus: <><path d="M12 5v14M5 12h14" /></>,
  chevronDown: <><path d="m6.5 9.5 5.5 5.5 5.5-5.5" /></>,
  chevronLeft: <><path d="M14.5 6 8.5 12l6 6" /></>,
  chevronRight: <><path d="m9.5 6 6 6-6 6" /></>,
  close: <><path d="M6.5 6.5l11 11M17.5 6.5l-11 11" /></>,
  check: <><path d="m5 12.5 4.5 4.5L19 7.5" /></>,
  logout: <><path d="M14 4.5H7A1.5 1.5 0 0 0 5.5 6v12A1.5 1.5 0 0 0 7 19.5h7" /><path d="M10.5 12h10M17 8.5l3.5 3.5-3.5 3.5" /></>,
  user: <><circle cx="12" cy="8.5" r="3.8" /><path d="M4.8 20c.9-3.6 3.7-5.8 7.2-5.8s6.3 2.2 7.2 5.8" /></>,
  card: <><rect x="3" y="5.5" width="18" height="13" rx="2.5" /><path d="M3 10h18M7 15h3.5" /></>,
  shield: <><path d="M12 3.2 19 6v5.6c0 4.4-2.9 7.7-7 9.2-4.1-1.5-7-4.8-7-9.2V6z" /><path d="m9 12 2.2 2.2L15.3 10" /></>,
  team: <><circle cx="12" cy="7.5" r="3" /><circle cx="5.5" cy="10.5" r="2.2" /><circle cx="18.5" cy="10.5" r="2.2" /><path d="M7.5 19.5c.4-3 2.2-5 4.5-5s4.1 2 4.5 5M2.5 18.5c.2-2 1.2-3.4 2.8-3.7M21.5 18.5c-.2-2-1.2-3.4-2.8-3.7" /></>,
  refresh: <><path d="M19.5 11.5A7.5 7.5 0 0 0 6.2 7.2L4.5 9" /><path d="M4.5 4.5V9H9" /><path d="M4.5 12.5a7.5 7.5 0 0 0 13.3 4.3l1.7-1.8" /><path d="M19.5 19.5V15H15" /></>,
  arrowUpRight: <><path d="M7 17 17 7M8.5 7H17v8.5" /></>,
  rupee: <><path d="M7 4.5h10M7 9h10M10 4.5c3.6 0 5 1.8 5 4.5S13.6 13.5 10 13.5H7.5l7.5 6" /></>,
  repeat: <><path d="M4.5 11V9.5A3 3 0 0 1 7.5 6.5h12M16.5 3.5l3 3-3 3" /><path d="M19.5 13v1.5a3 3 0 0 1-3 3h-12M7.5 20.5l-3-3 3-3" /></>,
  ledger: <><path d="M5.5 4.8A1.8 1.8 0 0 1 7.3 3h11.2v14.5H7.3a1.8 1.8 0 0 0-1.8 1.8z" /><path d="M5.5 19.3A1.7 1.7 0 0 0 7.2 21h11.3v-3.5M9.5 7.5h5.5M9.5 11h5.5" /></>,
  note: <><path d="M5 4.5A1.5 1.5 0 0 1 6.5 3h11A1.5 1.5 0 0 1 19 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19.5z" /><path d="M8.5 8h7M8.5 11.5h7M8.5 15h4" /></>,
  percent: <><path d="M18 6 6 18" /><circle cx="7.5" cy="7.5" r="2.3" /><circle cx="16.5" cy="16.5" r="2.3" /></>,
  truck: <><path d="M2.5 6.5A1.5 1.5 0 0 1 4 5h9.5v11h-11z" /><path d="M13.5 9h4l3 3.5V16h-7" /><circle cx="7" cy="17.5" r="1.8" /><circle cx="17" cy="17.5" r="1.8" /></>,
  building: <><path d="M4.5 20.5V5a1.5 1.5 0 0 1 1.5-1.5h7.5A1.5 1.5 0 0 1 15 5v15.5M15 9h3.5A1.5 1.5 0 0 1 20 10.5v10M3 20.5h18" /><path d="M8 7.5h3M8 11h3M8 14.5h3" /></>,
  download: <><path d="M12 4v11.5M7.5 11 12 15.5l4.5-4.5" /><path d="M4.5 14.5v3.5A2 2 0 0 0 6.5 20h11a2 2 0 0 0 2-2v-3.5" /></>,
  upload: <><path d="M12 15.5V4M7.5 8.5 12 4l4.5 4.5" /><path d="M4.5 14.5v3.5A2 2 0 0 0 6.5 20h11a2 2 0 0 0 2-2v-3.5" /></>,
  calendar: <><rect x="3.5" y="5" width="17" height="15.5" rx="3" /><path d="M3.5 10h17M8 3v4M16 3v4" /></>,
  cash: <><rect x="2.5" y="6" width="19" height="12" rx="2.5" /><circle cx="12" cy="12" r="2.6" /><path d="M6 9.5v5M18 9.5v5" /></>,
  bank: <><path d="M3 9 12 4l9 5" /><path d="M5 9.5v7.5M9.6 9.5v7.5M14.4 9.5v7.5M19 9.5v7.5M3 20h18" /></>,
  gst: <><rect x="4" y="3" width="16" height="18" rx="2.5" /><path d="M8 7.5h8M8 11.5h3M13 11.5h3M8 15.5h3M13 15.5h3" /></>,
  pulse: <><path d="M3 12.5h4l2.5-6 4 12 2.5-6H21" /></>,
  pie: <><path d="M12 3.5a8.5 8.5 0 1 0 8.5 8.5H12z" /><path d="M15 3.8A8.5 8.5 0 0 1 20.2 9H15z" /></>,
  sparkle: <><path d="M12 3.5c.6 4 2.4 5.9 6.5 6.5-4.1.6-5.9 2.5-6.5 6.5-.6-4-2.4-5.9-6.5-6.5 4.1-.6 5.9-2.5 6.5-6.5z" /><path d="M18.5 15.5c.3 1.6 1 2.3 2.5 2.5-1.5.3-2.2 1-2.5 2.5-.3-1.5-1-2.2-2.5-2.5 1.5-.2 2.2-.9 2.5-2.5z" /></>,
  alert: <><path d="M12 4 21 19.5H3z" /><path d="M12 10v4.2M12 17h.01" /></>,
  clock: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></>,
  inbox: <><path d="M3.5 13.5 6 5.5h12l2.5 8V19a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19z" /><path d="M3.5 13.5h5l1.5 2.5h4l1.5-2.5h5" /></>,
};

export function Glyph({ name, size = 22, stroke = 1.6, className, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round"
      className={className} style={style} aria-hidden="true" focusable="false">
      {P[name] || P.grid}
    </svg>
  );
}

// iOS system colours — light top stop → deeper bottom stop.
export const TINTS = {
  blue: ["#4aa3ff", "#0a6cff"],
  indigo: ["#7d7aff", "#4f4ce0"],
  green: ["#4cd964", "#22a33d"],
  orange: ["#ffb340", "#ff8200"],
  red: ["#ff6b6b", "#e5383b"],
  pink: ["#ff6f91", "#e8264f"],
  purple: ["#c86cf5", "#9a3fd1"],
  teal: ["#4fd1c5", "#119e94"],
  cyan: ["#5ac8fa", "#1a9fd8"],
  yellow: ["#ffd43b", "#f5a800"],
  graphite: ["#a0a0a8", "#6c6c74"],
};

// variant "vivid" = glossy app-icon tile (navigation); "soft" = pale tint + coloured
// glyph (content widgets — quieter, lets the numbers lead).
export function Tile({ name, tint = "blue", size = 36, variant = "vivid" }) {
  const [top, bottom] = TINTS[tint] || TINTS.blue;
  return (
    <span className={`v2-tile${variant === "soft" ? " v2-tile--soft" : ""}`} aria-hidden="true"
      style={{ "--top": top, "--tint": bottom, width: size, height: size }}>
      <Glyph name={name} size={Math.round(size * (variant === "soft" ? 0.54 : 0.58))} stroke={variant === "soft" ? 1.8 : 2} />
    </span>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Duotone widget icons — modelled on the reference: no container, one hue,
// a pale back layer + a solid front layer (white details read as cut-outs).
// Colour follows the accent (--duo-front / --duo-back in v2.css).
// ─────────────────────────────────────────────────────────────────────────────
const W = "#fff";
const S = { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };
const DUO = {
  rupee: {
    back: <circle cx="11.5" cy="12.8" r="9.2" />,
    front: <>
      <path d="M8.4 8.6h6.4M8.4 11.4h6.4M9.9 8.6c2.6 0 3.9 1.1 3.9 2.8s-1.3 2.8-3.9 2.8H8.4l4.9 3.9" {...S} strokeWidth="2" />
      <path d="M19.6 2.2c.3 1.6.9 2.2 2.4 2.5-1.5.3-2.1.9-2.4 2.5-.3-1.6-.9-2.2-2.4-2.5 1.5-.3 2.1-.9 2.4-2.5z" fill="currentColor" />
    </>,
  },
  wallet: {
    back: <rect x="5" y="3" width="14.5" height="9" rx="2.6" transform="rotate(-8 12 7.5)" />,
    front: <>
      <rect x="2.5" y="8" width="19" height="13" rx="3.6" fill="currentColor" />
      <rect x="14.6" y="12.3" width="6.9" height="4.6" rx="2.3" fill={W} />
      <circle cx="17.1" cy="14.6" r="1" fill="currentColor" />
    </>,
  },
  profit: {
    back: <rect x="2.5" y="3" width="19" height="18" rx="5.2" />,
    front: <>
      <path d="M6.5 15.8 10.4 12l2.6 2.5 4.6-5" {...S} strokeWidth="2.2" />
      <path d="M14.4 9.3h3.4v3.4" {...S} strokeWidth="2.2" />
    </>,
  },
  receivables: {
    back: <rect x="2.5" y="10" width="19" height="11" rx="3.6" />,
    front: <>
      <path d="M2.5 15h5l1.6 2.4h5.8L16.5 15h5v2.4a3.6 3.6 0 0 1-3.6 3.6H6.1a3.6 3.6 0 0 1-3.6-3.6z" fill="currentColor" />
      <path d="M12 2.8v8.4M8.6 7.9l3.4 3.4 3.4-3.4" {...S} strokeWidth="2.1" />
    </>,
  },
  payables: {
    back: <rect x="3.5" y="7" width="17" height="14" rx="3.8" />,
    front: <>
      <path d="M8.6 9.4V7a3.4 3.4 0 0 1 6.8 0v2.4" {...S} strokeWidth="2" />
      <path d="M3.5 13.6h17v3.6a3.8 3.8 0 0 1-3.8 3.8H7.3a3.8 3.8 0 0 1-3.8-3.8z" fill="currentColor" />
    </>,
  },
  gst: {
    back: <rect x="3.5" y="2.5" width="14" height="18.5" rx="3.2" />,
    front: <>
      <path d="M7 7.2h7M7 10.8h4.5" {...S} strokeWidth="1.9" />
      <circle cx="17" cy="16.6" r="5.4" fill="currentColor" />
      <path d="m15 18.6 4-4" stroke={W} strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="15.2" cy="14.8" r=".9" fill={W} /><circle cx="18.8" cy="18.4" r=".9" fill={W} />
    </>,
  },
  clock: {
    back: <circle cx="12" cy="12" r="9.5" />,
    front: <>
      <path d="M12 7v5.2l3.4 2.1" {...S} strokeWidth="2.2" />
      <circle cx="12" cy="12.2" r="1.4" fill="currentColor" />
    </>,
  },
  chart: {
    back: <><rect x="3" y="10.5" width="4.6" height="10.5" rx="1.6" /><rect x="16.4" y="7" width="4.6" height="14" rx="1.6" /></>,
    front: <rect x="9.7" y="3" width="4.6" height="18" rx="1.6" fill="currentColor" />,
  },
  cash: {
    back: <rect x="2" y="4.5" width="17" height="11" rx="2.8" />,
    front: <>
      <rect x="5" y="8.5" width="17" height="11" rx="2.8" fill="currentColor" />
      <circle cx="13.5" cy="14" r="2.5" fill={W} />
    </>,
  },
  pulse: {
    back: <rect x="2.5" y="3.5" width="19" height="17" rx="5.2" />,
    front: <path d="M5.5 12.6h3l2.1-4.6 3 8.2 2-3.6h3" {...S} strokeWidth="2.1" />,
  },
  pie: {
    back: <circle cx="11.2" cy="12.8" r="9" />,
    front: <path d="M13.2 2.2a8.8 8.8 0 0 1 8.6 8.6h-8.6z" fill="currentColor" />,
  },
  people: {
    back: <><circle cx="16.6" cy="7.8" r="3.1" /><path d="M12.4 20.2c.4-3.6 2.2-5.8 4.9-5.8s4.6 2.2 5 5.8z" /></>,
    front: <><circle cx="9" cy="8.2" r="3.7" fill="currentColor" /><path d="M2.3 20.6c.4-4.3 3-6.8 6.7-6.8s6.3 2.5 6.7 6.8z" fill="currentColor" /></>,
  },
  alert: {
    back: <path d="M10.3 3.9a2 2 0 0 1 3.4 0l8.1 14a2 2 0 0 1-1.7 3H3.9a2 2 0 0 1-1.7-3z" />,
    front: <><path d="M12 9.2v4.6" {...S} strokeWidth="2.3" /><circle cx="12" cy="17" r="1.3" fill="currentColor" /></>,
  },
  invoice: {
    back: <rect x="4.5" y="2.5" width="15" height="19" rx="3.2" />,
    front: <><rect x="7.8" y="7" width="8.4" height="2.1" rx="1.05" fill="currentColor" /><rect x="7.8" y="11" width="8.4" height="2.1" rx="1.05" fill="currentColor" /><rect x="7.8" y="15" width="5.2" height="2.1" rx="1.05" fill="currentColor" /></>,
  },
  clients: {
    back: <rect x="3" y="3" width="18" height="18" rx="5.2" />,
    front: <><circle cx="12" cy="10" r="3.3" fill="currentColor" /><path d="M6.6 18.6c.9-2.7 3-4.2 5.4-4.2s4.5 1.5 5.4 4.2z" fill="currentColor" /></>,
  },
  box: {
    back: <path d="M12 2.6 20.6 7.2 12 11.8 3.4 7.2z" />,
    front: <><path d="M3.4 8.8 11.2 13v8.4l-7.8-4.2z" fill="currentColor" /><path d="M20.6 8.8 12.8 13v8.4l7.8-4.2z" fill="currentColor" opacity=".72" /></>,
  },
  repeat: {
    back: <circle cx="12" cy="12" r="9.5" />,
    front: <><path d="M7.4 11a4.8 4.8 0 0 1 8.4-2.6M16.6 13a4.8 4.8 0 0 1-8.4 2.6" {...S} strokeWidth="2.1" /><path d="M16.2 5.6v3h-3M7.8 18.4v-3h3" {...S} strokeWidth="2.1" /></>,
  },
  mail: {
    back: <rect x="2.5" y="5" width="19" height="14" rx="3.4" />,
    front: <path d="M3.6 7.4 12 13l8.4-5.6" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" fill="none" />,
  },
  phone: {
    back: <rect x="6" y="2.5" width="12" height="19" rx="3.2" />,
    front: <><rect x="9.6" y="17.2" width="4.8" height="1.9" rx=".95" fill="currentColor" /><path d="M9 2.5h6v1.6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z" fill="currentColor" /></>,
  },
  pin: {
    back: <ellipse cx="12" cy="20.2" rx="6.5" ry="2" />,
    front: <><path d="M12 2.5a6.8 6.8 0 0 1 6.8 6.8c0 4.6-5.2 9.4-6.3 10.3a.8.8 0 0 1-1 0C10.4 18.7 5.2 13.9 5.2 9.3A6.8 6.8 0 0 1 12 2.5z" fill="currentColor" /><circle cx="12" cy="9.3" r="2.5" fill="#fff" /></>,
  },
  ledger: {
    back: <rect x="5" y="2.5" width="15" height="19" rx="3" />,
    front: <><path d="M3.5 6.5h3M3.5 12h3M3.5 17.5h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><rect x="9.5" y="7" width="7" height="2" rx="1" fill="currentColor" /><rect x="9.5" y="11" width="5" height="2" rx="1" fill="currentColor" /></>,
  },
  note: {
    back: <rect x="4" y="2.5" width="16" height="19" rx="3.2" />,
    front: <><rect x="7.5" y="7" width="9" height="2" rx="1" fill="currentColor" /><rect x="7.5" y="11" width="6" height="2" rx="1" fill="currentColor" /><path d="M13.5 21.5v-4a1.5 1.5 0 0 1 1.5-1.5h5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></>,
  },
  percent: {
    back: <circle cx="12" cy="12" r="9.5" />,
    front: <><path d="m8.2 15.8 7.6-7.6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /><circle cx="8.8" cy="8.8" r="1.9" fill="currentColor" /><circle cx="15.2" cy="15.2" r="1.9" fill="currentColor" /></>,
  },
  truck: {
    back: <path d="M14 8.5h3.6l3.4 3.8v4.7H14z" />,
    front: <><rect x="2" y="5" width="12.5" height="12" rx="2.2" fill="currentColor" /><circle cx="7" cy="18" r="2.2" fill="currentColor" stroke="#fff" strokeWidth="1.4" /><circle cx="17.2" cy="18" r="2.2" fill="currentColor" stroke="#fff" strokeWidth="1.4" /></>,
  },
  building: {
    back: <rect x="13" y="8" width="8" height="13" rx="2" />,
    front: <><rect x="3" y="3" width="11" height="18" rx="2.4" fill="currentColor" /><path d="M6.5 7.5h4M6.5 11h4M6.5 14.5h4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" /></>,
  },
  sparkle: {
    back: <circle cx="12" cy="12" r="9.5" />,
    front: <path d="M12 6.2c.5 3.3 2 4.8 5.3 5.3-3.3.5-4.8 2-5.3 5.3-.5-3.3-2-4.8-5.3-5.3 3.3-.5 4.8-2 5.3-5.3z" fill="currentColor" />,
  },
};

export function Duo({ name, size = 30 }) {
  const d = DUO[name] || DUO.sparkle;
  return (
    <svg className="v2-duo" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <g fill="var(--duo-back)">{d.back}</g>
      <g>{d.front}</g>
    </svg>
  );
}

// Widget icon: duotone by default; the Appearance experiment can swap in tiles.
// Both are rendered; CSS (data-v2-icons) shows one.
export function WidgetIcon({ name, glyph, tint = "blue", size = 30 }) {
  return (
    <span className="v2-wicon" style={{ width: size, height: size }} aria-hidden="true">
      <Duo name={name} size={size} />
      <Tile name={glyph || "grid"} tint={tint} size={size} variant="soft" />
    </span>
  );
}
